import { Component, Input } from '@angular/core';
import { IdpDataAlbertaCa } from '@govalta-emu/keycloak-auth-service';

@Component({
  standalone: false,
  selector: 'common-verified-info-display',
  templateUrl: './verified-info-display.component.html',
  styleUrls: ['./verified-info-display.component.scss'],
})
export class VerifiedInfoDisplayComponent {
  _profileData: IdpDataAlbertaCa;
  @Input() set profileData(value: IdpDataAlbertaCa) {
    if (!this._profileData && value) {
      this._profileData = value;
    }
  }
  get profileData() {
    return this._profileData;
  }

  @Input() hiddenFields: string[];

  getFullName(firstName: string, lastName: string, middleName?: string, valueIfEmpty = '-') {
    let fullName = '';
    if (!firstName && !lastName && !middleName) {
      fullName = valueIfEmpty;
    } else {
      if (firstName) {
        fullName = firstName;
      }
      if (middleName) {
        fullName = `${fullName} ${middleName.trim()}`;
      }
      if (lastName) {
        fullName = `${fullName} ${lastName.trim()}`;
      }
      fullName = fullName.trim();
    }
    return fullName;
  }

  isVisible(field: string) {
    //check if field should display
    if (this.hiddenFields?.length && this.hiddenFields?.includes(field)) {
      return false;
    }
    return true;
  }
}
